// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2zpwR","clinicsSelect":"TableHeading_clinicsSelect__1MSC7"};